/** 与 server/constants/logisticsCompany.js 对齐 */
export const LOGISTICS_COMPANIES = [
  "顺丰快递",
  "极兔物流",
  "EMS中国邮政",
  "中通快递",
  "中通快运",
  "韵达快递",
  "圆通快递",
  "申通快递",
  "京东快递",
  "百世快递",
  "百世快运",
  "跨越速运",
  "安能",
  "顺心捷达",
  "壹米滴答",
  "德邦",
];

/** @type {{ company: string, patterns: RegExp[] }[]} */
const CARRIER_RULES = [
  { company: "顺丰快递", patterns: [/^SF\d{10,15}$/i, /^S\d{11}$/] },
  { company: "极兔物流", patterns: [/^JT\d{10,15}$/i] },
  { company: "圆通快递", patterns: [/^YT\d{10,15}$/i, /^88\d{10,12}$/, /^D\d{10,15}$/i] },
  { company: "中通快递", patterns: [/^7\d{12,13}$/, /^75\d{11,13}$/, /^7353\d{10}$/] },
  { company: "韵达快递", patterns: [/^43\d{11}$/, /^44\d{11}$/, /^45\d{11}$/, /^46\d{11}$/, /^47\d{11}$/] },
  { company: "申通快递", patterns: [/^77\d{11,13}$/, /^772\d{11,13}$/] },
  { company: "EMS中国邮政", patterns: [/^[A-Z]{2}\d{9}[A-Z]{2}$/i, /^E[A-Z]\d{9}[A-Z]{2}$/i, /^10\d{11}$/] },
  { company: "京东快递", patterns: [/^JD[A-Z]?\d{10,}$/i, /^JDV\d{10,}$/i] },
  { company: "百世快递", patterns: [/^55\d{11,13}$/, /^70\d{11,13}$/] },
  { company: "跨越速运", patterns: [/^KYE\d{8,}$/i, /^KY\d{10,}$/i] },
];

const MIN_TRACKING_LENGTH = 8;
const MAX_TRACKING_LENGTH = 32;

/** EAN-13 商品码（13 位纯数字） */
function isEan13(text) {
  if (!/^\d{13}$/.test(text)) return false;
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += Number(text[i]) * (i % 2 === 0 ? 1 : 3);
  }
  const check = (10 - (sum % 10)) % 10;
  return check === Number(text[12]);
}

/**
 * 规范化条码原始文本
 * @param {string} raw
 * @returns {string}
 */
export function normalizeBarcodeText(raw) {
  return String(raw || "")
    .trim()
    .replace(/\s+/g, "")
    .toUpperCase();
}

/**
 * 判断是否为疑似快递单号（过滤商品码等噪声）
 * @param {string} text
 * @returns {boolean}
 */
export function isLikelyTrackingNo(text) {
  const normalized = normalizeBarcodeText(text);
  if (!normalized) return false;
  if (normalized.length < MIN_TRACKING_LENGTH || normalized.length > MAX_TRACKING_LENGTH) return false;
  if (isEan13(normalized)) return false;
  if (!/^[A-Z0-9-]+$/.test(normalized)) return false;
  if (/^\d+$/.test(normalized) && normalized.length < 10) return false;
  return CARRIER_RULES.some(rule => rule.patterns.some(pattern => pattern.test(normalized)));
}

/**
 * 根据单号推断物流公司
 * @param {string} trackingNo
 * @returns {string|null}
 */
export function matchCarrierByTrackingNo(trackingNo) {
  const normalized = normalizeBarcodeText(trackingNo);
  if (!normalized) return null;
  for (let i = 0; i < CARRIER_RULES.length; i++) {
    const rule = CARRIER_RULES[i];
    if (rule.patterns.some(pattern => pattern.test(normalized))) {
      return rule.company;
    }
  }
  return null;
}

/**
 * 从条码文本列表提取物流单号及公司
 * @param {string[]} rawBarcodes
 * @returns {{ logisticsNos: string[], logisticsCompanies: string[] }}
 */
export function parseLogisticsFromBarcodes(rawBarcodes) {
  const logisticsNos = [];
  const companySet = new Set();

  (rawBarcodes || []).forEach(raw => {
    const text = normalizeBarcodeText(raw);
    if (!isLikelyTrackingNo(text)) return;
    if (logisticsNos.indexOf(text) === -1) {
      logisticsNos.push(text);
    }
    const company = matchCarrierByTrackingNo(text);
    if (company) companySet.add(company);
  });

  return {
    logisticsNos,
    logisticsCompanies: LOGISTICS_COMPANIES.filter(name => companySet.has(name)),
  };
}
